import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#ededed"
export default makeBasicTheme(mainColor)